module.exports = __webpack_public_path__ + "img/cancel-red.5814a4b6.svg";